// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//import FastClick from 'fastclick'
import loading from '@/components/loading'
import failedTips from '@/components/failedTips'
// import PublicFooter from '@/components/footer'
import store from './store'
import router from './router'
import Vant from 'vant'
import { Lazyload } from 'vant';
import LangArray from '@/config/Lang'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'
import util from '@/config/util'
import zh_tran from '@/config/zhTranslate'
import wx from '@/config/WeixinSdk.js'
import VueClipboard from 'vue-clipboard2'
import iwebsocket from '@/config/websocket'
import VConsole from 'vconsole'

import VueTagTextarea from 'vue-tag-textarea1'
import 'vue-tag-textarea1/lib/vue-tag-textarea.css'
Vue.use(VueTagTextarea)

/*//全局引入video-player插件
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)*/

//rem引入：引入文件后，查看页面的html节点，是否有被自动添加 font-size。
//import '@/config/rem'

/*let vConsole = new VConsole();//初始化
Vue.use(vConsole);//设为全局*/

if(util.getStorage('vconsole') == 1) {
	let vConsole = new VConsole();
	Vue.use(vConsole);
}
Vue.config.devtools = true;

Vue.use(require('vue-wechat-title'))
Vue.use(Vant)
Vue.use(Lazyload, {
	lazyComponent: true,
	loading: '',
})
Vue.use(VueClipboard)
console.log('iloadingiloadingiloadingiloading')
Vue.component('iloading', loading);
Vue.component('failedTips', failedTips);

Vue.config.ignoredElements = ["wx-open-subscribe"];
Vue.config.productionTip = false
Vue.prototype.util = util
Vue.prototype.$zh_tran = zh_tran
Vue.prototype.wx = wx
Vue.prototype.isWeixin = util.isWeixin();
Vue.prototype.theme = util.getStorage('theme');

Vue.prototype.util.initBaseParams();
Vue.prototype.Lang = LangArray[DollarType]
Vue.prototype.wx.init();
Vue.prototype.iwebsocket = iwebsocket.init();
//util.setStorage('locationInfo', {"last_location_x":37.74543,"address":"缅甸木姐中缅街","location_x":"23.775276","location_y":"98.826091","city":"","expire":1900665719});
//util.setStorage('locationInfo', {"last_location_x":37.74543,"address":"云南省临沧市镇康县南伞镇人民政府","location_x":"23.775276","location_y":"98.826091","city":"","expire":1900665719});
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js